"use client";

import { Compass } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { AspectRatio } from "@/components/ui/aspect-ratio";
export default function FoundationalPillars() {
  const header = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const quote = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const divider = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const disciplines = [{
    number: "01",
    title: "Strategic Brand Identity",
    description: "Crafting visual narratives that resonate. From logo architecture to comprehensive design systems, our work is built for lasting market presence.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/brand_identity_design.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/brand_identity_design.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/brand_identity_design.webp-wvc-sizes",
    alt: "Minimalist brand identity design sketches and color palettes",
    span: "lg:col-span-1",
    height: "lg:h-[500px]",
    offset: ""
  }, {
    number: "02",
    title: "Digital Experience Design",
    description: "Intuitive interfaces for modern users. Every interaction is meticulously mapped, tested, and refined to ensure seamless digital journeys.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/digital_experience_ux.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/digital_experience_ux.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/digital_experience_ux.webp-wvc-sizes",
    alt: "Modern UI/UX interface design on a professional workstation",
    span: "lg:col-span-1",
    height: "lg:h-[500px]",
    offset: ""
  }, {
    number: "03",
    title: "Creative Content Strategy",
    description: "Storytelling that drives engagement. We develop content frameworks that align your brand voice with the needs of your target audience.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/creative_content_strategy.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/creative_content_strategy.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/creative_content_strategy.webp-wvc-sizes",
    alt: "Creative content planning session with mood boards and notes",
    span: "lg:col-span-1",
    height: "lg:h-[500px]",
    offset: ""
  }];
  return <section data-section-id="3193" id="foundationalpillars" className="bg-background text-foreground py-24 md:py-32 lg:py-[180px] overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8 items-end mb-20 md:mb-28">
          <div ref={header.ref} className={`lg:col-span-7 transition-all duration-[900ms] ease-out ${header.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            <p className="font-default text-xs md:text-sm tracking-[0.25em] uppercase text-muted-foreground mb-8">STORYTELLING</p>
            <h2 className="font-default font-light text-4xl md:text-5xl lg:text-[72px] leading-[1.05] tracking-tight text-foreground">Lionia Project racconta la tua storia - senza filtri, con molta curiosità.</h2>
          </div>

          <div ref={quote.ref} className={`lg:col-span-5 lg:text-right transition-all duration-[1100ms] delay-200 ease-out ${quote.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            
          </div>
        </div>

        
        

        
        <div ref={divider.ref} className={`mt-24 md:mt-32 flex items-center gap-6 transition-all duration-[1000ms] ease-out ${divider.isVisible ? "opacity-100" : "opacity-0"}`}>
          <div className="h-px flex-1 bg-border" />
          <Compass className="size-5 text-muted-foreground" strokeWidth={1.25} aria-hidden="true" />
          <div className="h-px flex-1 bg-border" />
        </div>
      </div>
    </section>;
}